/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1CourseCourseidLanguagesIdFilesFiletype200,
  DeleteApiV1CourseCourseidLanguagesIdFilesFiletype401,
  DeleteApiV1CourseCourseidLanguagesIdFilesFiletype404,
  DeleteApiV1CourseCourseidLanguagesIdFilesFiletype500,
  DeleteApiV1CourseCourseidLanguagesIdFilesFiletypeMutationResponse,
  DeleteApiV1CourseCourseidLanguagesIdFilesFiletypePathParams,
} from "../../types/courseLangsController/DeleteApiV1CourseCourseidLanguagesIdFilesFiletype.ts";
import { courseLangDetailViewModelSchema } from "../courseLangDetailViewModelSchema.ts";
import { eCourseLangFileTypeSchema } from "../eCourseLangFileTypeSchema.ts";

export const deleteApiV1CourseCourseidLanguagesIdFilesFiletypePathParamsSchema =
  z.object({
    courseId: z.coerce.number().int(),
    id: z.coerce.number().int(),
    fileType: z
      .lazy(() => eCourseLangFileTypeSchema)
      .describe("1 = Manual | 2 = Regiment | 3 = UspDocument | "),
  }) as unknown as ToZod<DeleteApiV1CourseCourseidLanguagesIdFilesFiletypePathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1CourseCourseidLanguagesIdFilesFiletype200Schema =
  z.lazy(
    () => courseLangDetailViewModelSchema,
  ) as unknown as ToZod<DeleteApiV1CourseCourseidLanguagesIdFilesFiletype200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1CourseCourseidLanguagesIdFilesFiletype401Schema =
  z.any() as unknown as ToZod<DeleteApiV1CourseCourseidLanguagesIdFilesFiletype401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1CourseCourseidLanguagesIdFilesFiletype404Schema =
  z.any() as unknown as ToZod<DeleteApiV1CourseCourseidLanguagesIdFilesFiletype404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1CourseCourseidLanguagesIdFilesFiletype500Schema =
  z.any() as unknown as ToZod<DeleteApiV1CourseCourseidLanguagesIdFilesFiletype500>;

export const deleteApiV1CourseCourseidLanguagesIdFilesFiletypeMutationResponseSchema =
  z.lazy(
    () => deleteApiV1CourseCourseidLanguagesIdFilesFiletype200Schema,
  ) as unknown as ToZod<DeleteApiV1CourseCourseidLanguagesIdFilesFiletypeMutationResponse>;
